/* eslint-disable no-sequences */
import axios from "axios";

// consts
import { apiToken, apiUrl_forNotifications } from "./constants";

// axios cancel token initializer
const CancelToken = axios.CancelToken;

// get notifications details
export let cancelGetNotificationsDataApi;
export async function getNotificationsDataApi(token) {
    if (token) {
        const emails = await axios.get(apiUrl_forNotifications + "email/data", {
            headers: {
                Authorization: `Bearer ${token}`,
                "Api-Token": apiToken,
                "Access-Token": "",
            },
            cancelToken: new CancelToken(function executor(c) {
                // An executor function receives a cancel function as a parameter
                cancelGetNotificationsDataApi = c;
            }),
        });
        return emails;
    } else {
        console.log("Please add required parameters");
    }
}

// add logo
export let cancelAddLogoApi;
export async function addLogoApi(token, image) {
    if (token && image) {
        let formData = new FormData();
        formData.append("images[]", image, image.name);

        const emails = await axios.post(
            apiUrl_forNotifications + "email/logo",
            formData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelAddLogoApi = c;
                }),
            }
        );
        return emails;
    } else {
        console.log("Please add required parameters");
    }
}

// verify DKIM
export let cancelVerifyDKIMApi;
export async function verifyDKIMApi(token) {
    if (token) {
        const emails = await axios.put(
            apiUrl_forNotifications + "verify/verifyDkim",
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelVerifyDKIMApi = c;
                }),
            }
        );
        return emails;
    } else {
        console.log("Please add required parameters");
    }
}

// verify return path
export let cancelVerifyReturnPathApi;
export async function verifyReturnPathApi(token) {
    if (token) {
        const emails = await axios.put(
            apiUrl_forNotifications + "verify/verifyReturnPath",
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelVerifyReturnPathApi = c;
                }),
            }
        );
        return emails;
    } else {
        console.log("Please add required parameters");
    }
}

// add domain
export let cancelAddDomainApi;
export async function addDomainApi(token, domain) {
    if (token && domain) {
        const emails = await axios.post(
            apiUrl_forNotifications + "add/domain",
            { domain },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelAddDomainApi = c;
                }),
            }
        );
        return emails;
    } else {
        console.log("Please add required parameters");
    }
}

// add forward customer email to admin
export let cancelAddCustomerEmailToAdminStatusApi;
export async function addCustomerEmailToAdminStatusApi(token, status) {
    if (token) {
        const emails = await axios.put(
            apiUrl_forNotifications + "forward-customer-emails-to-admin",
            { forward_customer_email_to_admin: status },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelAddCustomerEmailToAdminStatusApi = c;
                }),
            }
        );
        return emails;
    } else {
        console.log("Please add required parameters");
    }
}

// delete domain
export let cancelDeleteDomainApi;
export async function deleteDomainApi(token) {
    if (token) {
        const emails = await axios.delete(apiUrl_forNotifications + "domain", {
            headers: {
                Authorization: `Bearer ${token}`,
                "Api-Token": apiToken,
                "Access-Token": "",
            },
            cancelToken: new CancelToken(function executor(c) {
                // An executor function receives a cancel function as a parameter
                cancelDeleteDomainApi = c;
            }),
        });
        return emails;
    } else {
        console.log("Please add required parameters");
    }
}

// add from email
export let cancelAddFromEmailApi;
export async function addFromEmailApi(token, { from_email, from_name }) {
    if (token && from_email && from_name) {
        const emails = await axios.post(
            apiUrl_forNotifications + "add/from/email",
            { from_email, from_name },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelAddFromEmailApi = c;
                }),
            }
        );
        return emails;
    } else {
        console.log("Please add required parameters");
    }
}

// add admin emails
export let cancelAddAdminEmailsApi;
export async function addAdminEmailsApi(token, emailsArray) {
    if (token && emailsArray?.length) {
        const emails = await axios.put(
            apiUrl_forNotifications + "admin/emails",
            { admin_emails: emailsArray },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelAddAdminEmailsApi = c;
                }),
            }
        );
        return emails;
    } else {
        console.log("Please add required parameters");
    }
}
